// extracted by mini-css-extract-plugin
export var avatar = "_m9-3";
export var avatarContainer = "_m9-2";
export var avatarSpacer = "_m9-5";
export var avatarSpacerContainer = "_m9-4";
export var avatarStackContainer = "_m9-1";
export var bubble = "_m9-0";
export var remainderBubble = "_m9-6";